import { Anchor, Box, Text } from '@zillow/constellation-10';

const LoadingFailed = () => (
  <Box
    css={{
      marginTop: 'token(spacing.xl) !important',
      marginBottom: 'token(spacing.xl) !important',
    }}
  >
    <Text>
      Could not load page.&nbsp;
      <Anchor href="/renter-hub">Return to renter hub</Anchor>
    </Text>
  </Box>
);

export default LoadingFailed;
